import React from "react";
import { atom, useRecoilState } from "recoil";
import styled from "styled-components";
import {
  PointTabBar,
  PointTabColumn,
  PointTabContainer,
  PointTabText,
} from "../../Benefit/Point/PointTab";

export const payFailTabState = atom<number>({
  key: "payFailTabState",
  default: 0,
});

export default function PayFailTab() {
  const [tab, setTab] = useRecoilState(payFailTabState);

  return (
    <PointTabContainer>
      <PointTabColumn onClick={() => setTab(0)}>
        <PointTabText isActive={Boolean(tab === 0)}>정산 실패</PointTabText>

        <PayFailTabBar tab={tab} />
      </PointTabColumn>

      <PointTabColumn onClick={() => setTab(1)}>
        <PointTabText isActive={Boolean(tab === 1)}>
          단건 결제 실패
        </PointTabText>
      </PointTabColumn>
    </PointTabContainer>
  );
}

const PayFailTabBar = styled(PointTabBar)`
  width: ${({ tab }) => (tab === 0 ? 67 : 103)}px;
  left: ${({ tab }) => (tab === 0 ? 0 : 88)}px;
`;
